import { getCurrentInstance } from 'vue'
import { nanoid } from 'nanoid'

const AUTOFILL_SALT_LENGTH = 32

const autofillNames = new WeakMap<object, string>()

const saltedName = (): string => `cp-${nanoid(AUTOFILL_SALT_LENGTH)}`

export type IBrowserAutofillDefaults = {
	autocomplete: string
	readonly name: string
}

export const useAutofillName = (): string => {
	const instance = getCurrentInstance()

	if (!instance) return saltedName()

	const stored = autofillNames.get(instance)

	if (stored) return stored

	const name = saltedName()

	autofillNames.set(instance, name)

	return name
}

export const browserAutofillDefaults = (): IBrowserAutofillDefaults => ({
	autocomplete: 'suppress',
	get name (): string {
		return useAutofillName()
	}
})
